/* ==========================================================================
   Teefactory — Competition form → Google Sheets
   1. Validates the form in the browser.
   2. Sends the entry to the Google Apps Script web app (data-sheet-url).
   3. If "Also email entries" is on, then submits the normal Shopify contact
      form (page reloads with Shopify's success message + store email).
      Otherwise shows the success message without reloading.
   If the sheet URL is empty, the form behaves like a normal Shopify form.
   ========================================================================== */
(function () {
  'use strict';

  function init(card) {
    if (!card || card.__tfcInit) return;
    var form = card.querySelector('form');
    var url = (card.getAttribute('data-sheet-url') || '').trim();
    if (!form || !url) return; // no sheet configured -> plain Shopify form
    card.__tfcInit = true;

    var sendEmail = card.getAttribute('data-send-email') === 'true';
    var okBox = form.querySelector('[data-tfc-ok]');
    var errBox = form.querySelector('[data-tfc-err]');
    var btn = form.querySelector('[data-tfc-submit]');
    var nativeSubmit = HTMLFormElement.prototype.submit;
    var busy = false;

    function show(box) {
      [okBox, errBox].forEach(function (b) { if (b) b.hidden = b !== box; });
      if (box) { box.focus({ preventScroll: true }); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    function collect() {
      var data = new FormData();
      form.querySelectorAll('[data-key]').forEach(function (el) {
        var key = el.getAttribute('data-key');
        var val = el.type === 'checkbox' ? (el.checked ? 'Yes' : 'No') : (el.value || '').trim();
        data.append(key, val);
      });
      data.append('page_url', window.location.href.split('#')[0]);
      data.append('submitted_at', new Date().toISOString());
      return data;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!form.reportValidity()) return;

      busy = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      show(null);

      fetch(url, { method: 'POST', body: collect() })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.result !== 'success') throw new Error((res && res.message) || 'Sheet error');
          if (sendEmail) {
            nativeSubmit.call(form); // Shopify email + reload with Shopify success message
            return;
          }
          form.querySelectorAll('.tfc-field, .tfc-field--full').forEach(function (f) { f.hidden = true; });
          show(okBox);
        })
        .catch(function (err) {
          console.error('[TF competition form]', err);
          if (sendEmail) {
            // Sheet failed, but don't lose the entry: still send it by Shopify email.
            nativeSubmit.call(form);
            return;
          }
          show(errBox);
        })
        .finally(function () {
          busy = false;
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  function boot() { document.querySelectorAll('[data-tfc-sheet-form]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
